<template>
    <div
        class="backToTop JARVIS_main_BackToTop"
        v-bind:class="{ _isBsi: !isAsi }"
        v-bind:style="backToTopStyle"
        v-on:click="scrollToTop(300)"
    >
        <SvgIcon iconName="systemIcon_arrowBottom" /> {{ i18n.t('backToTop_button') }}
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { CSSProperties } from 'vue';
    import { computed, defineComponent } from 'vue';
    import { useJackpotDisplay } from '@/libraries/composables/useJackpotDisplay';
    import { i18n } from '@/libraries/i18n';
    import { scrollToTop } from '@/libraries/utils/dom';
    import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
    import { useRootStore } from '@/stores/rootStore';
    import SvgIcon from '@/svg/SvgIcon.vue';

    export default defineComponent({
        name: 'BackToTop',
        components: {
            SvgIcon,
        },
        setup() {
            const { isAsi } = storeToRefs(useRootStore());
            const { backToTopHeight } = storeToRefs(useHeaderDisplayStore());
            const { isShowJackpotWidget } = useJackpotDisplay();

            const backToTopStyle = computed<CSSProperties>(() => (isAsi.value
                ? { bottom: `${backToTopHeight.value + (isShowJackpotWidget.value ? 30 : 0)}px` }
                : {}));

            return {
                i18n,

                isAsi,
                backToTopStyle,
                scrollToTop,
            };
        },
    });
</script>

<style lang='scss' scoped>
    .backToTop {
        position: fixed;
        z-index: 80;
        left: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 15px 2px 10px;
        margin: 1rem;
        background: rgba(42, 103, 193, 60%);
        border-radius: 2rem;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 50%);
        color: #ffffff;
        transform: translateX(-50%);

        .svgIcon {
            width: 1.5rem;
            height: 1.5rem;
            fill: $white;
            transform: rotate(180deg);
        }

        &._isBsi {
            bottom: 6rem;
        }
    }

    @media only screen and (resolution: 3dppx) and (device-height: 812px) and (device-width: 375px) {
        .backToTop._isBsi {
            bottom: 8rem;
        }
    }
</style>
